import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, withKeys as _withKeys, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-6a3fdd94"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_2 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_3 = /*#__PURE__*/_createTextVNode("添加");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("Excel导入");

const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("批量邀请人脸识别");

const _hoisted_7 = /*#__PURE__*/_createTextVNode("编辑");

const _hoisted_8 = /*#__PURE__*/_createTextVNode("禁用");

const _hoisted_9 = /*#__PURE__*/_createTextVNode("启用");

const _hoisted_10 = /*#__PURE__*/_createTextVNode("绑定合集管理员");

const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 1
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 2
};
const _hoisted_16 = ["onClick"];
const _hoisted_17 = {
  key: 1
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 请下载Excel模板，严格按照字段的属性填写相关信息，保存后上传到系统，任何字段信息有误均会导致导入失败。一次导入上限为500条。 ", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.登录账号必填，且全平台不可重复；", -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "2.联系人、手机为必填项；", -1));

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "3.其它字段信息可为空，为空则自动填充默认值，如有填写则务必保证相关信息真实有效存在", -1));

const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "请下载模板并填写“姓名、手机号”后上传，系统将按行匹配账号并批量发起人脸识别邀请。", -1));

const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "若姓名和手机号无法匹配账号，或用户未完成身份证二要素验证，将在失败明细中展示原因。", -1));

import { ref, defineAsyncComponent, computed } from 'vue';
import { useStore } from 'vuex';
import { getVexTableProps, dateFormat } from '@/config';
import dayjs from 'dayjs';
import { getSalesmanList, disableSalesmanMan, getDictItemList, exportForAsync, inviteFaceRecognition, cancelFaceRecognitionInvite, getFaceRecognitionSuccessRecords } from '@/request';
import { uploadSales, uploadFaceRecognitionInvite, importSalesmanExcel, importFaceRecognitionInviteExcel } from '@/request/api';
import { ElMessage, ElMessageBox } from 'element-plus';
import UploadModal from '@/components/UploadModal.vue';
import AssignCourseCollectionModal from './component/AssignCourseCollectionModal.vue';
export default {
  name: 'SalesmanAccountManage',

  setup(__props) {
    const store = useStore();
    const userType = computed(() => store.state.user.userType);
    const AddSalesmanModal = defineAsyncComponent(() => import('./component/AddSalesmanModal.vue'));
    const defaultForm = {
      salesmanKeyWd: '',
      supplierKeyWd: '',
      linkMan: '',
      linkPhone: '',
      levelType: 0,
      employeeType: '',
      registeredChannels: '',
      isAuth: '',
      faceRecognitionStatus: '',
      // endTime: dayjs(Date.now()).format(dateFormat),
      // startTime: dayjs(Date.now() - 30 * 24 * 60 * 60 * 1000).format(dateFormat)
      endTime: '',
      startTime: ''
    };
    const showUploadModel = ref(false);
    const showFaceRecognitionUploadModel = ref(false);
    const uploadOption = {
      action: uploadSales.url,
      name: 'salesman_excel',
      templateLink: importSalesmanExcel.url,
      title: '导入'
    };
    const faceRecognitionUploadOption = {
      action: uploadFaceRecognitionInvite.url,
      name: 'salesman_excel',
      templateLink: importFaceRecognitionInviteExcel.url,
      title: '批量邀请人脸识别'
    };
    const form = ref(_objectSpread({}, defaultForm));
    const formRef = ref();
    const editData = ref(null);
    const table = ref();
    const total = ref(0);
    const isFenguan = ref(false);
    const exportAuth = ref(false);
    const showAddModal = ref(false);
    const tableOptions = getVexTableProps({
      columns: [{
        title: '登录账号',
        field: 'loginName',
        width: '150px',
        showOverflow: true
      }, {
        title: '姓名',
        field: 'linkMan',
        width: '150px',
        showOverflow: true
      }, {
        title: '手机号',
        field: 'linkPhone',
        width: '150px',
        showOverflow: true
      }, {
        title: '所属团队',
        field: 'supplierName',
        width: '220px',
        showOverflow: true
      }, {
        title: '注册方式',
        field: 'registeredChannels',
        width: '150px',
        showOverflow: true
      }, {
        title: '创建时间',
        field: 'createAt',
        width: '250px',
        showOverflow: true
      }, // {
      //   title: '实名认证',
      //   field: 'hasAuth',
      //   width: '80px'
      // },
      {
        title: '身份证二要素验证',
        field: 'isAuth',
        width: '160px',
        slots: {
          default: 'isAuth'
        }
      }, {
        title: '身份证号',
        field: 'authIdcard',
        width: '200px'
      }, {
        title: '是否已通过人脸识别',
        field: 'isFaceRecognition',
        width: '180px',
        slots: {
          default: 'isFaceRecognition'
        }
      }, {
        title: '最近一次验证时间',
        field: 'latestFaceRecognitionTime',
        width: '200px',
        showOverflow: true
      }, {
        title: '人脸识别验证次数',
        field: 'faceRecognitionCount',
        width: '160px',
        slots: {
          default: 'faceRecognitionCount'
        }
      }, {
        title: '操作',
        field: 'operation',
        fixed: 'right',
        width: '520px',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getSalesmanList(_objectSpread({
              page: page.currentPage,
              rows: page.pageSize
            }, form.value)).then(data => {
              data.rows.forEach(item => {
                item.createAt = dayjs(item.createAt).format('YYYY-MM-DD HH:mm:ss');

                if (item.supplierName === null || item.supplierName === '') {
                  item.levelTypeText = '-';
                } else if (item.levelType === null || item.levelType === '') {
                  item.levelTypeText = '省级团队';
                } else if (item.levelType === 1) {
                  item.levelTypeText = '市级团队';
                } else if (item.levelType === 2) {
                  item.levelTypeText = '区级团队';
                } else {
                  item.levelTypeText = '未知';
                }
              });
              total.value = data.total;
              isFenguan.value = data.isFenguan;
              exportAuth.value = data.exportAuth;
              console.log("isFenguan", isFenguan.value);
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });

    function edit(row) {
      editData.value = row;
      showAddModal.value = true;
    }

    function updateStatus(row, status) {
      let desc = status === 4 ? '禁用后客户将无法登录,您确定要禁用吗?' : '启用后客户将恢复系统登录权限，您确定要启用吗？';
      ElMessageBox.confirm(desc, {
        title: '提示',
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        disableSalesmanMan({
          supAccountId: row.supAccountId,
          userStatus: status,
          __repeat: true,
          __warn: false
        }).then(data => {
          if (data.code === '1001') {
            ElMessageBox.confirm(data.msg, '提示', {
              confirmButtonText: '是',
              cancelButtonText: '否',
              type: 'warning'
            }).then(() => {
              disableSalesmanMan({
                supAccountId: row.supAccountId,
                userStatus: status,
                comfirmStatus: '1',
                __repeat: true,
                __warn: false
              }).then(res => {
                if (res.success) {
                  ElMessage.success('操作成功');
                  table.value.commitProxy('query');
                } else {
                  ElMessage.error(data.msg);
                }
              });
            }).catch(() => {});
          } else if (data.success) {
            ElMessage.success('操作成功');
            table.value.commitProxy('query');
          } else {
            ElMessage.error(data.msg);
          }
        });
      });
    }

    function search() {
      // form.value.searchType = '1';
      table.value.commitProxy('reload');
    }

    function reset() {
      form.value = _objectSpread({}, defaultForm);
      table.value.commitProxy('reload');
    }

    function add() {
      showAddModal.value = true;
      editData.value = null;
    }

    function addSuccess() {
      table.value.commitProxy('query');
    }

    function faceRecognitionBatchInviteSuccess(data) {
      if (data && data.success) {
        table.value.commitProxy('reload');
      }
    }

    const registerChannelList = ref([]);

    function getRegisterChannelType() {
      getDictItemList({
        dictItemType: 'registered_channel_type'
      }).then(res => {
        registerChannelList.value = res.data;
      });
    }

    getRegisterChannelType();

    function exportHandle() {
      let body = _objectSpread({}, form.value); // if (isNullOrDefined(body.startTime)) {
      //   body.startTime = '';
      // }
      // if (isNullOrDefined(body.endTime)) {
      //   body.endTime = '';
      // }


      exportForAsync(_objectSpread({
        count: total.value,
        fileName: '业务员账号列表',
        modularflag: 'salesManList',
        methodName: '/admin/salesman/exportDataList'
      }, body));
    }

    const assignCollectionModal = ref({
      show: false,
      row: null
    });
    const faceRecognitionDialog = ref({
      visible: false,
      records: []
    });

    function showFaceRecognitionRecords(row) {
      getFaceRecognitionSuccessRecords({
        supAccountId: row.supAccountId
      }).then(res => {
        const list = Array.isArray(res.data) ? res.data : [];
        faceRecognitionDialog.value.records = list.map(item => ({
          passTime: item
        }));
        faceRecognitionDialog.value.visible = true;
      });
    }

    function openAssignCollection(row) {
      assignCollectionModal.value = {
        show: true,
        row
      };
    }

    function inviteFaceRecognitionHandle(row) {
      if (Number(row.hasFaceRecognitionInvite) === 1) {
        ElMessageBox.confirm('请确认是否取消此用户的人脸识别认证邀请', {
          title: '提示',
          cancelButtonText: '取消',
          confirmButtonText: '确认'
        }).then(() => {
          cancelFaceRecognitionInvite({}, {
            params: {
              supAccountId: row.supAccountId
            }
          }).then(data => {
            if (data.success) {
              ElMessage.success('已取消人脸识别认证邀请');
              table.value.commitProxy('reload');
            }
          });
        });
        return;
      } //if (Number(row.isAuth) !== 1) {
      //  ElMessage.warning('当前账号未完成身份证二要素验证，无法邀请人脸识别');
      //  return;
      //}


      ElMessageBox.confirm('请确认是否向此用户在万药通发起人脸识别认证邀请', {
        title: '提示',
        cancelButtonText: '取消',
        confirmButtonText: '确认'
      }).then(() => {
        inviteFaceRecognition({}, {
          params: {
            supAccountId: row.supAccountId
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('人脸识别认证邀请已发起');
            table.value.commitProxy('reload');
          }
        });
      });
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_table_column = _resolveComponent("el-table-column");

      const _component_el_table = _resolveComponent("el-table");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        "label-width": "80px",
        onKeydown: _cache[10] || (_cache[10] = _withKeys($event => table.value.commitProxy('reload'), ["enter"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "登录账号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.salesmanKeyWd,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.salesmanKeyWd = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "姓名"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkMan,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.linkMan = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [isFenguan.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "所属团队"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.supplierKeyWd,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.value.supplierKeyWd = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [isFenguan.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "团队层级"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.levelType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.value.levelType = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "省级团队",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "市级团队",
                  value: 2
                }), _createVNode(_component_el_option, {
                  label: "区级团队",
                  value: 3
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "手机号"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.linkPhone,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.value.linkPhone = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "注册方式"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.registeredChannels,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.value.registeredChannels = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(registerChannelList.value, item => {
                  return _openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.value,
                    key: item.value
                  }, null, 8, ["label", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [isFenguan.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "开始时间",
              prop: "startTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.startTime,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.value.startTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "开始时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [isFenguan.value ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: "结束时间",
              prop: "endTime"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_date_picker, {
                modelValue: form.value.endTime,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => form.value.endTime = $event),
                type: "date",
                "value-format": _unref(dateFormat),
                placeholder: "结束时间"
              }, null, 8, ["modelValue", "value-format"])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_row, null, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "身份证二要素验证",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.isAuth,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => form.value.isAuth = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "是",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "否",
                  value: 0
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "人脸识别"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: form.value.faceRecognitionStatus,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => form.value.faceRecognitionStatus = $event)
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }), _createVNode(_component_el_option, {
                  label: "是",
                  value: 1
                }), _createVNode(_component_el_option, {
                  label: "否",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "邀请认证中",
                  value: 2
                })]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: search
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Plus",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "UploadFilled",
          onClick: _cache[11] || (_cache[11] = $event => showUploadModel.value = true)
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          onClick: exportHandle
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 1
        })) : _createCommentVNode("", true), exportAuth.value ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          icon: "UploadFilled",
          onClick: _cache[12] || (_cache[12] = $event => showFaceRecognitionUploadModel.value = true)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 1
        })) : _createCommentVNode("", true)]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Edit",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_7]),
          _: 2
        }, 1032, ["onClick"]), row.userStatus === 1 && _unref(userType) !== 3 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "danger",
          icon: "CircleCloseFilled",
          onClick: $event => updateStatus(row, 4)
        }, {
          default: _withCtx(() => [_hoisted_8]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), row.userStatus === 4 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "success",
          icon: "CircleCheckFilled",
          onClick: $event => updateStatus(row, 1)
        }, {
          default: _withCtx(() => [_hoisted_9]),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          type: "warning",
          onClick: $event => inviteFaceRecognitionHandle(row)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(Number(row.hasFaceRecognitionInvite) === 1 ? '取消邀请' : '邀请人脸识别'), 1)]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "primary",
          onClick: $event => openAssignCollection(row)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 2
        }, 1032, ["onClick"])]),
        isAuth: _withCtx(({
          row
        }) => [row.isAuth === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_11, "是")) : (_openBlock(), _createElementBlock("span", _hoisted_12, "否"))]),
        isFaceRecognition: _withCtx(({
          row
        }) => [Number(row.hasFaceRecognitionInvite) === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_13, "认证中")) : Number(row.isFaceRecognition) === 1 ? (_openBlock(), _createElementBlock("span", _hoisted_14, "是")) : (_openBlock(), _createElementBlock("span", _hoisted_15, "否"))]),
        faceRecognitionCount: _withCtx(({
          row
        }) => [Number(row.faceRecognitionCount) > 0 ? (_openBlock(), _createElementBlock("span", {
          key: 0,
          class: "clickable-link",
          onClick: $event => showFaceRecognitionRecords(row)
        }, _toDisplayString(row.faceRecognitionCount), 9, _hoisted_16)) : (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(row.faceRecognitionCount || 0), 1))]),
        _: 1
      }, 16), _createVNode(_component_el_dialog, {
        title: "人脸识别认证通过记录",
        modelValue: faceRecognitionDialog.value.visible,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => faceRecognitionDialog.value.visible = $event),
        width: "520px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table, {
          data: faceRecognitionDialog.value.records,
          border: "",
          "max-height": "400"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "passTime",
            label: "通过时间",
            "min-width": "220"
          })]),
          _: 1
        }, 8, ["data"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_unref(AddSalesmanModal), {
        modelValue: showAddModal.value,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => showAddModal.value = $event),
        editData: editData.value,
        onSuccess: addSuccess
      }, null, 8, ["modelValue", "editData"]), _createVNode(UploadModal, {
        option: uploadOption,
        modelValue: showUploadModel.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => showUploadModel.value = $event)
      }, {
        help: _withCtx(() => [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(UploadModal, {
        option: faceRecognitionUploadOption,
        modelValue: showFaceRecognitionUploadModel.value,
        "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => showFaceRecognitionUploadModel.value = $event),
        onSuccess: faceRecognitionBatchInviteSuccess
      }, {
        help: _withCtx(() => [_hoisted_22, _hoisted_23]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(AssignCourseCollectionModal, {
        modelValue: assignCollectionModal.value.show,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => assignCollectionModal.value.show = $event),
        row: assignCollectionModal.value.row
      }, null, 8, ["modelValue", "row"])]);
    };
  }

};